import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
export function OnboardingButton(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Button variant="secondary" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}